import React from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import ProductCard from './ProductCard';

const CollectionView = ({ products = [] }) => {
  const { type } = useParams();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const qGender = queryParams.get('gender') || '';
  const qSize = queryParams.get('size') || '';
  const qPrice = queryParams.get('price') || '';
  const searchQueryText = queryParams.get('query') || '';

  const filteredItems = products.filter(product => {
    const prodGender = (product.gender || '').toLowerCase().trim();
    const prodCategory = (product.category || '').toLowerCase().trim();
    const prodName = (product.name || '').toLowerCase().trim();
    const prodDesc = (product.description || '').toLowerCase().trim();
    const prodDetails = (product.details || '').toLowerCase().trim();
    const prodSizes = product.sizes || [];
    const activePrice = product.discountPrice || product.price;

    if (type === 'search') {
      if (searchQueryText) {
        const cleanQuery = searchQueryText.toLowerCase().trim();
        const matchesKeyword = 
          prodName.includes(cleanQuery) || 
          prodDesc.includes(cleanQuery) || 
          prodDetails.includes(cleanQuery) || 
          prodGender.includes(cleanQuery) || 
          prodCategory.includes(cleanQuery);
        
        if (!matchesKeyword) return false;
      }

      if (qGender && prodGender !== qGender.toLowerCase()) return false;
      if (qSize && !prodSizes.includes(qSize.toUpperCase())) return false;
      if (qPrice && activePrice > Number(qPrice)) return false;
      
      return true;
    }

    if (type === 'men-regular') return prodGender === 'men' && prodCategory === 'regular fit';
    if (type === 'men-oversized') return prodGender === 'men' && prodCategory === 'oversized';
    if (type === 'unisex') return prodGender === 'unisex';
    if (type === 'women-regular') return prodGender === 'women' && prodCategory === 'regular fit';
    if (type === 'women-oversized') return prodGender === 'women' && prodCategory === 'oversized';

    return true;
  });

  const getPageTitle = () => {
    if (type === 'search') {
      return searchQueryText 
        ? `RESULTS FOR: "${searchQueryText.toUpperCase()}"` 
        : "FILTERED SEARCH DETAILS";
    }
    if (type === 'men-regular') return "MEN — REGULAR FIT";
    if (type === 'men-oversized') return "MEN — OVERSIZED";
    if (type === 'unisex') return "UNISEX SIGNATURE PIECES";
    if (type === 'women-regular') return "WOMEN — REGULAR FIT";
    if (type === 'women-oversized') return "WOMEN — OVERSIZED";
    return "THE MODISCHE COLLECTION";
  };

  return (
    <div className="min-h-screen bg-[#F5F5DC] pt-40 pb-32 px-6 max-w-[1600px] mx-auto">
      <div className="flex flex-col md:flex-row md:justify-between md:items-end mb-16 border-b border-[#664229]/10 pb-8 gap-6">
        <div>
          <Link to="/" className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] font-black text-[#F5F5DC] bg-[#2C1E12] px-4 py-2 mb-6 rounded-sm shadow-md hover:bg-[#664229] transition-all duration-300 transform hover:-translate-x-1 no-underline">
            <span>←</span> <span>Return Home</span>
          </Link>
          <h1 className="text-4xl font-extrabold tracking-tighter text-[#2C1E12] uppercase leading-none">{getPageTitle()}</h1>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {filteredItems.length > 0 ? (
          filteredItems.map(product => (
            <ProductCard 
              key={product._id || product.id} 
              id={product._id || product.id} 
              _id={product._id || product.id}
              name={product.name} 
              price={product.price} 
              discountPrice={product.discountPrice} 
              images={product.images || (product.image ? [product.image] : [])} 
              image={product.image || (product.images && product.images[0])}
              sizes={product.sizes || ['S', 'M', 'L', 'XL']}
            />
          ))
        ) : (
          <div className="col-span-full text-center py-24 text-[#664229]/50 text-xs tracking-widest uppercase border border-dashed border-[#664229]/20 rounded-sm">
            No garments match your active search selection criteria.
          </div>
        )}
      </div>
    </div>
  );
};

export default CollectionView;